import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: []
  },
  getters: {
    details: state => state.details
  },
  actions: {
    fetchSearch({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Notifications/api/Receivers?name=" + name)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    fetchReceiverById({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("Notifications/api/NotificationTemplate/ReceiverSettings/" + id)
          .then(r => {
            commit("setDetails", r);
            commit("setLoading", false);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    updateReceiverAndCc({ commit, dispatch }, model) {
      return ajax.put("Notifications/api/NotificationTemplate", model);
    },
    createReceiver({ commit, dispatch }, model) {
      return ajax.post("Notifications/api/Receivers", model).then(() => {});
    },
    modifyReceiver({ commit, dispatch }, model) {
      return ajax.put("Notifications/api/Receivers", model).then(() => {});
    },
    deleteReceiver({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Notifications/api/Receivers",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    }
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    }
  }
};
